import instanceAxios from '../config/api'
import {
  ActionsDistributionResponse,
  Risque,
  RisqueResponse,
  SourceRisqueType,
} from '../types/risqueTypes'
const API_URL = '/risques'

export const getAllRisques = async ({
  page,
  pageSize,
  search,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<RisqueResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch risque.')
  }
}
export const deleteRisqueApi = async (RisqueId: string) => {
  try {
    const response = await instanceAxios.delete<RisqueResponse>(
      `${API_URL}/` + RisqueId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch risques.')
  }
}

export const addRisqueApi = async (newRisque: Risque): Promise<Risque> => {
  try {
    const response = await instanceAxios.post<Risque>(`${API_URL}`, newRisque)
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add Risque.')
  }
}

export const getRisquebyIdApi = async (RisqueId: string) => {
  try {
    const response = await instanceAxios.get<Risque>(`${API_URL}/` + RisqueId)
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch risque.')
  }
}

export const updateRisqueApi = async (
  updatedRisque: Risque,
  RisqueId: string
): Promise<Risque> => {
  try {
    const response = await instanceAxios.put<Risque>(
      `${API_URL}/${RisqueId}`,
      updatedRisque
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUT Risque.')
  }
}
export const getRisquesByMissionIdApi = async (MissionId: string) => {
  try {
    const response = await instanceAxios.get<RisqueResponse>(
      `missions/getRisques/` + MissionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch risques.')
  }
}

export const getRisqueByActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<RisqueResponse>(
      `actions/getRisques/` + ActionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch Risque.')
  }
}
export const addRisquesToActionApi = async (
  SourceRisque: string[],
  _id: string
): Promise<RisqueResponse> => {
  try {
    const response = await instanceAxios.put<RisqueResponse>(
      `actions/addRisques/${_id}`,
      SourceRisque
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}

export const removeRisquesFromActionApi = async (
  SourceRisque: SourceRisqueType,
  _id: string
): Promise<RisqueResponse> => {
  try {
    const response = await instanceAxios.put<RisqueResponse>(
      `actions/removeRisques/${_id}`,
      SourceRisque
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}

export const getRisqueByPlanIdApi = async (PlanId: string) => {
  try {
    const response = await instanceAxios.get<RisqueResponse>(
      `plans/getRisques/` + PlanId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Risques.')
  }
}
export const getActionsDistributionBySecurityControl = async (
  riskId: string
): Promise<ActionsDistributionResponse> => {
  try {
    const response = await instanceAxios.get<ActionsDistributionResponse>(
      `${API_URL}/getActionsDistributionBySecurityControl/${riskId}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch actions distribution.')
  }
}
export const extractRisksFromFileApi = async (
  file: File,
  planId: string
): Promise<{ message: string; count: number; data: Risque[] }> => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('planId', planId)

    const response = await instanceAxios.post(
      `${API_URL}/extract-risk`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to extract risks from file.')
  }
}
